import { render, staticRenderFns } from "./UcMeterConsumptions.yaml?vue&type=template&id=6b6cae9c&component"
import script from "./UcMeterConsumptions.yaml?vue&type=script&lang=ts&component"
export * from "./UcMeterConsumptions.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports